import type { ReactNode } from "react";
import { Img } from "@/components/image";
import type { DietCatalogCateringType } from "@/features/diets/types";

// Cart list group (MPL-3757): a grey panel with the catering header (logo +
// name) followed by the diet cards that belong to that catering.
export const CartCateringGroup = ({
  catering,
  children,
}: {
  catering: DietCatalogCateringType;
  children: ReactNode;
}) => (
  <section className="space-y-4 rounded-xl border border-brand-grey2 bg-brand-grey1-200 p-3 md:space-y-6 md:p-4 lg:p-6">
    <div className="flex items-center gap-4">
      <span className="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-brand-white p-1">
        <Img
          alt={catering.logo.alt ?? catering.name}
          className="size-12 object-contain"
          height={48}
          src={catering.logo.url}
          width={48}
        />
      </span>
      <p className="font-medium text-base text-brand-green1-300">
        {catering.name}
      </p>
    </div>
    {children}
  </section>
);
